import { FORGD_SYSTEM_PROJECT_ID } from '@forgd/shared/constants'

/**
 * Rescues project-scoped URLs whose projectId the user cannot access by
 * swapping in their default project. The auth page middleware does the same,
 * but allowPreLogin pages (e.g. /project/:id) never run it.
 */
export default defineNuxtRouteMiddleware(async (to) => {
  if (import.meta.server) {
    return
  }

  const urlProjectId = to.path.match(/^\/project\/([^/]+)/)?.[1]
  // The system demo project is never in the user's orgs; MMM handles its URLs
  if (!urlProjectId || urlProjectId === FORGD_SYSTEM_PROJECT_ID) {
    return
  }

  const auth = useAuth()
  const isLoggedIn = await auth.waitForAuth({ from: 'project-access middleware' })
  if (!isLoggedIn || !auth.project) {
    return
  }

  const { project: urlProject } = auth.findProjectAndOrg(urlProjectId)
  if (!urlProject && auth.project.id !== urlProjectId) {
    return navigateTo(to.fullPath.replace(`/project/${urlProjectId}`, `/project/${auth.project.id}`), { replace: true })
  }
})
